<ng-container *ngIf="!isLoading && projectOptions.length > 0 else loadingView">
    <div class="cas-flex-column">
        <form [formGroup]="advancedForm" class="cas-flex-column-8">
            <acabim-form-block labelWidth="4" [labelAlign]="'right'" [colonize]="true">
                <acabim-form-input-wrapper>
                    <acabim-form-input-label>Project</acabim-form-input-label>
                    <acabim-form-input-content [shortField]="true">
                        <p-dropdown
                            [options]="projectOptions"
                            formControlName="selectedProject"
                            optionLabel="label"
                            placeholder="Select a project"></p-dropdown>
                    </acabim-form-input-content>
                </acabim-form-input-wrapper>
            </acabim-form-block>
        </form>
        <acabim-admin-fund-table *ngIf="selected" [accountInfo]="selected"></acabim-admin-fund-table>
    </div>
</ng-container>

<ng-template #loadingView>
    <acabim-loading-view></acabim-loading-view>
</ng-template>
